export const MASTERCLASS = 'master-class'
export const LIVECONCERT = 'live-concert'
export const WORKSHOP = 'workshop'
